import { generateTealiumPayload } from "../utils/generateTealiumPayload.es.js";
import { logger } from "../../../utils/logger.es.js";
import { w as waitFor } from "../../../waitFor-1b67bbb8.js";
import "../utils/addHashedData.es.js";
import "../utils/hashUtils.es.js";
import "../../constants/analytics.es.js";
import "../utils/extractClickData.es.js";
import "../utils/extractCommonPayload.es.js";
import "../../../analytics-plugin-original-source.browser.es-e6f690eb.js";
import "../utils/getUtmParams.es.js";
import "../../../mapKeys-251205e5.js";
import "../../../pickFields-27454ddf.js";
import "../utils/extractIds.es.js";
import "../utils/pageUtils.es.js";
import "../../constants/profileFields.es.js";
import "../utils/getBrowserID.es.js";
import "../../../cookies-04bd2321.js";
import "../../../v4-88c20f3b.js";
import "../utils/extractFormData.es.js";
import "../../../server/validation/defaultSchema.es.js";
import "../../../_commonjsHelpers-7a77ea84.js";
import "../../../videoData-64ad3ea2.js";
const utag = () => window.utag;
const analyticsTealium = ({
  userConfig,
  application,
  includedFields
}) => {
  return {
    config: Object.assign({}, userConfig),
    name: "analytics-tealium",
    page: async ({ payload }) => {
      let uTagResolver;
      const uTagPromise = new Promise((resolve) => {
        uTagResolver = resolve;
      });
      waitFor(utag, async () => {
        const payloadToSend = await generateTealiumPayload(
          application,
          includedFields,
          payload,
          "page"
        );
        const uTagCallBack = () => {
          uTagResolver();
          logger.info(
            `ANALYTICS :: tealium :: page - ${payloadToSend == null ? void 0 : payloadToSend.event_name}`,
            payloadToSend
          );
        };
        utag().view(payloadToSend, uTagCallBack);
      });
      return uTagPromise;
    },
    track: async ({ payload, instance }) => {
      var _a, _b;
      const pageDataProperties = (_b = (_a = instance.getState("page")) == null ? void 0 : _a.last) == null ? void 0 : _b.properties;
      const pageName = payload.properties.page_name || pageDataProperties.page_name || pageDataProperties.application_data.page_name;
      payload.properties.page_name = pageName;
      let uTagResolver;
      const uTagPromise = new Promise((resolve) => {
        uTagResolver = resolve;
      });
      waitFor(utag, async () => {
        const payloadToSend = await generateTealiumPayload(
          application,
          includedFields,
          payload,
          "track"
        );
        const uTagCallBack = () => {
          uTagResolver();
          logger.info(
            `ANALYTICS :: tealium :: track - ${payloadToSend == null ? void 0 : payloadToSend.event_name}`,
            payloadToSend
          );
        };
        utag().link(payloadToSend, uTagCallBack);
      });
      return uTagPromise;
    }
  };
};
export {
  analyticsTealium
};
